"use strict";

exports.__esModule = true;
exports.DashboardWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DashboardElement = require("./DashboardElement");
var _DashboardFields = require("./DashboardFields");
var _DashboardHeader = require("./DashboardHeader");
var _DashboardWidgetThumbnail = require("./DashboardWidgetThumbnail");
var _EditableDashboardElement = require("./EditableDashboardElement");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DashboardWidget = exports.DashboardWidget = {
  name: "Dashboard",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "DashboardWidget.label",
    defaultMessage: "Dashboard"
  }),
  ignoreHeading: true,
  icon: "dashboard",
  createElement: function createElement(props) {
    return {
      type: "Dashboard",
      props: Object.assign({
        width: 1024,
        height: 768,
        rowCount: 12,
        columnCount: 12,
        padding: 16
      }, props),
      children: []
    };
  },
  showInPalette: false,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: ["devices"],
  optionalProps: ["padding"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: ["x", "y", "width", "height"],
  propConstraints: {
    width: {
      "default": 1024,
      min: 128,
      max: 3840
    },
    height: {
      "default": 768,
      min: 128,
      max: 2160
    }
  },
  components: {
    Header: _DashboardHeader.DashboardHeader,
    Element: _DashboardElement.DashboardElement,
    Fields: _DashboardFields.DashboardFields,
    Editable: _EditableDashboardElement.EditableDashboardElement,
    Thumbnail: _DashboardWidgetThumbnail.DashboardWidgetThumbnail
  }
};